import React from 'react';
import DataTable from '../../../DataTable';
import {inject, observer} from 'mobx-react';
import {observable, action, toJS} from 'mobx';
import Spinner from "../../../Spinner";

@inject('maintenanceTypeStore')
@observer
class MaintenanceTypeList extends React.Component {

  slug = 'monitoring/config/maintenance_type';
  actionColumn = [
    {key: 'id', label: 'Id'},
    {key: 'caption', label: 'Caption'},
    {key: 'description', label: 'Description'},
    {key: 'color', label: 'Color'},
  ];

  handleDelete = (idOrIds) => {
    console.log('handleDelete', idOrIds);
    this.props.maintenanceTypeStore.removeItems(idOrIds);
  };

  render() {
    const {maintenanceTypeStore} = this.props;

    let data = maintenanceTypeStore.items.map(({id, caption, description, color}) => ({
      id,
      caption,
      description,
      color: <svg viewBox="0 0 20 20" x="10" width="20">
        <circle cx="10" cy="10" r="8" stroke="grey" strokeWidth="0.5px" fill={color} />
      </svg>
      // color: <i className='fa fa-circle' style={{color}}/>
    }));

    return (
      <div>
        <DataTable data={data} slug={this.slug} columns={this.actionColumn} onDelete={this.handleDelete}
                   allowAdd
                   allowEdit
                   allowDelete
                   resource='inventory'
        />
        {maintenanceTypeStore.isLoading && <Spinner/>}
        {this.props.children}
      </div>
    );
  }
}

export default MaintenanceTypeList;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/MaintenanceType/MaintenanceTypeList.js